import { render, staticRenderFns } from "./CertificateMailModal.vue?vue&type=template&id=59994426&"
import script from "./CertificateMailModal.vue?vue&type=script&lang=ts&"
export * from "./CertificateMailModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports